<template>
  <div>
    <v-card
      color="rgba(0,0,0,0)"
      class="font-weight-bold"
      elevation="0"
      :disabled="isAvailable"
      @click="clickAction"
    >
      <v-row justify="center">
        <v-col>
          <v-row justify="center">
            <v-img :src="iconImageUrl" max-width="30%" min-height="80%" class="icon"></v-img>
          </v-row>
          <v-row justify="center">
            <p>{{iconName}}</p>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>

export default {
  name: "SwitchIcon",
  data: () => ({
  }),
  computed:{
    imageUrl() {
      return require(this.iconImageUrl)
    }
  },
  created() {
  },
  methods: {
    clickAction(){
      this.$emit('clickAction');
    }
  },
  components: {
  },
  props: ['iconName', 'iconImageUrl', 'isAvailable']
};
</script>

<style scoped>
p {
  margin: 0;
  color: #fff;
  font-size: 0.6em;
}
.icon {
  margin-bottom: 10px;
}
@media screen and (max-width: 350px) {
  p {
    font-size: 0.6em;
  }
}
@media screen and (min-width: 351px) and (max-width: 768px) {
  p {
    font-size: 0.6em;
  }
}
@media screen and (min-width: 768px) and (max-width: 1024px) {
  p {
    font-size: 0.8em;
  }
}
@media screen and (min-width: 1024px) {
  p {
    font-size: 1em;
  }
}
</style>
